import React, {useMemo} from "react";
import {
    Cell,
    Legend,
    Pie,
    PieChart,
    ResponsiveContainer,
    Tooltip
} from "recharts";
import {LeaveRequestSummary} from "../../../../../domains/models/leave";
import EmptyData from "../../../../../page-components/common/empty-data/empty-data";
import {CalendarX2} from "lucide-react";
import LoadingSkeleton from "../../../../../page-components/common/loading-skeleton/loading-skeleton";

interface RequestCountChartProps {
    summary: LeaveRequestSummary | null;
    loading: boolean
}

const RequestCountChart = ({summary, loading}: RequestCountChartProps) => {

    const PIE_COLORS = [
        'var(--request-pending)',
        'var( --request-accepted)',
        'var( --request-rejected)',
        'var( --request-cancelled)',
    ];

    const chartData = useMemo(() => {
        if (!summary) return [];

        return [
            {
                name: "Pending",
                value: summary.pendingRequest,
            },

            {
                name: "Approved",
                value: summary.approvedRequest,
            },
            {
                name: "Rejected",
                value: summary.rejectedRequest,
            },
            {
                name: "Cancelled",
                value: summary.cancelledRequest,
            },
        ];
    }, [summary]);

    return (
        <LoadingSkeleton loading={loading}>
            <div>
                {
                    summary?.totalRequest ?
                        <section>
                            <ResponsiveContainer width="100%" height={200}>
                                <PieChart>
                                    <Pie
                                        data={chartData}
                                        cx="50%"
                                        cy="50%"
                                        innerRadius={55}
                                        outerRadius={80}
                                        paddingAngle={3}
                                        dataKey="value"
                                        nameKey="name"
                                        stroke="none"
                                    >
                                        {chartData.map((_, index) => (
                                            <Cell
                                                key={`cell-${index}`}
                                                fill={PIE_COLORS[index % PIE_COLORS.length]}
                                                stroke="none"
                                            />
                                        ))}
                                    </Pie>

                                    <Tooltip
                                        contentStyle={{
                                            background: '#FFFFFF',
                                            border: '1px solid #e2e8f0',
                                            borderRadius: '8px',
                                            fontSize: '12px',
                                            fontWeight: 600,
                                            color: '#0f172a',
                                        }}
                                    />

                                    <Legend
                                        layout="vertical"
                                        verticalAlign="middle"
                                        align="right"
                                        iconType="circle"
                                        iconSize={10}
                                        formatter={(value, entry: any) => {
                                            return (
                                                <span
                                                    style={{
                                                        color: 'var(--pn-text-primary)',
                                                        fontSize: '13px',
                                                        fontWeight: 500,
                                                    }}
                                                >
                {value} : {entry.payload.value}
            </span>
                                            );
                                        }}
                                    />
                                </PieChart>
                            </ResponsiveContainer>
                        </section> :
                        <EmptyData
                            icon={<CalendarX2 className={'leave-request-empty-data-icon'}/>}
                            title={"No Leave Requests Found"}
                            subtitle={"There are currently no pending or past leave requests to review!"}
                        />
                }
            </div>
        </LoadingSkeleton>
    );
};

export default RequestCountChart;